import type { ApiErrorType } from '@/core/types';

import { toast } from '@/components/snackbar';

export const processApiError = (
  error: ApiErrorType,
  setError: (field: any, error: any) => void,
  t: (key: string, options?: Record<string, any>) => string,
  customMessage: string
) => {
  // Toast message
  toast.error(error?.detail || error?.message || customMessage || t('notification.error'));

  if (!error || typeof error !== 'object') {
    return;
  }

  // Нормализуем источник ошибок
  const fieldErrors = error.errors || error.data || error;

  if (typeof fieldErrors !== 'object' || fieldErrors === null) {
    return;
  }

  Object.entries(fieldErrors).forEach(([field, message]) => {
    if (!message) return;

    // API может вернуть массив сообщений
    if (Array.isArray(message)) {
      const firstMessage = message.find((m) => typeof m === 'string');
      if (firstMessage) {
        setError(field, { type: 'manual', message: firstMessage });
      }
      return;
    }

    // Обычная строка
    if (typeof message === 'string') {
      setError(field, { type: 'manual', message });
    }
  });
};
